import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErroPage } from '@/features/erro/page-erro/ErroPage';

export const Route = createFileRoute('/p/erro')({
    component: ErroPage,
    validateSearch: z.object({ error: z.string() }),
});
